import * as React from "react";
import { Card, useRouteParams } from "@bb-vendure/admin-ui/react";
import { useInjector } from "@bb-vendure/admin-ui/react";
import { DataService, I18nService } from "@bb-vendure/admin-ui/core";
import SpecRow from "./SpecRow";
import {
  GetAllDefaultProductInformationsDocument,
  SortOrder,
  GetProductDetailDocument,
} from "src/generated-gql/graphql";
import { Subject, takeUntil } from "rxjs";

const Spec = () => {
  const { params } = useRouteParams();
  const id = params?.id;
  const dataService = useInjector(DataService);
  const translator = useInjector(I18nService);
  const [isFreeGift, setIsFreeGift] = React.useState(false);
  const [pVariants, setPVariants] = React.useState<any>([]);
  const [defaultValues, setDefaultValues] = React.useState<
    {
      id: string;
      name: string;
      value: string;
    }[]
  >([]);
  const destroy$ = React.useRef(new Subject<void>());

  dataService.product
    .getProductVariantsForProduct(
      {
        take: 100,
        skip: 0,
        sort: {},
      },
      id
    )
    .stream$.subscribe((data) => {
      setPVariants(data.productVariants.items);
    });

  React.useEffect(() => {
    dataService
      .query(GetAllDefaultProductInformationsDocument, {
        options: {
          sort: {
            createdAt: SortOrder.Desc,
          },
        },
      })
      .single$.subscribe((data) => {
        setDefaultValues(data.defaultProductInformations.items);
      });

    dataService
      .query(GetProductDetailDocument, {
        id,
      })
      .stream$.pipe(takeUntil(destroy$.current))
      .subscribe((data) => {
        setIsFreeGift(data.product?.customFields?.freeGifts ?? false);
      });
    return () => {
      destroy$.current.next();
      destroy$.current.complete();
    };
  }, []);

  return (
    <>
      {id !== "create" && !isFreeGift && (
        <div style={{ marginBottom: "1rem" }}>
          <Card title={translator.translate('catalog.product-information')}>
            {pVariants &&
              pVariants.map((varItem) => (
                <SpecRow
                  key={varItem.id}
                  id={varItem.id}
                  name={varItem.name}
                  defaultValues={defaultValues}
                />
              ))}
          </Card>
        </div>
      )}
    </>
  );
};

export default Spec;
